import { render, staticRenderFns } from "./goodsAward.vue?vue&type=template&id=121ec0a8&scoped=true"
import script from "./goodsAward.vue?vue&type=script&lang=js"
export * from "./goodsAward.vue?vue&type=script&lang=js"
import style0 from "./goodsAward.vue?vue&type=style&index=0&id=121ec0a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121ec0a8",
  null
  
)

export default component.exports